const ColorPicker = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m16.947 10.585 2.475-2.475a2.5 2.5 0 1 0-3.536-3.536L13.412 7.05l-.708-.707a.5.5 0 1 0-.707.707l.707.707-7.049 7.05a2.5 2.5 0 0 0-.644 1.11l-.69 2.532a1 1 0 0 0 1.227 1.228l2.533-.691a2.5 2.5 0 0 0 1.11-.644l7.049-7.05.707.708a.5.5 0 1 0 .707-.707zm-1.414 0-2.121-2.122-7.05 7.05a1.5 1.5 0 0 0-.386.665l-.69 2.533 2.532-.69a1.5 1.5 0 0 0 .666-.387z"
      clipRule="evenodd"
    />
  </>
)
export default ColorPicker
